<template>
  <custom-card>
    <template v-slot:title>
      <v-avatar :image="streamerData?.user?.profile_pic ?? Utils.getImgUrl('user_profile_pic.png')" size="36"></v-avatar>
      {{ streamerData?.user.username ?? route.params.streamer }}
    </template>
    <template v-slot:content>
      <kicklet-tabs :tabs="tabs" @click="navigateToStats" :activeTab="tab" />
      <v-window v-model="tab" class="mt-3 w-100">
        <v-window-item
          style="min-height: 200px"
          class="fill-height"
          value="profile"
        >
          <profile
            :streamer-data="streamerData"
          />
        </v-window-item>
        <v-window-item
          v-if="profileSettings?.rankingActive"
          style="min-height: 200px"
          class="fill-height"
          value="ranking"
        >
          <ranking
            :kicklet-user="kickletUser"
          />
        </v-window-item>
        <v-window-item
          v-if="profileSettings?.songRequestsActive"
          style="min-height: 200px"
          class="fill-height"
          value="song-queue"
        >
          <song-queue
            :kicklet-user="kickletUser"
          />
        </v-window-item>
        <v-window-item
          v-if="profileSettings?.commandListActive"
          style="min-height: 200px"
          class="fill-height"
          value="commands"
        >
          <commands
            :kicklet-user="kickletUser"
          />
        </v-window-item>
      </v-window>
    </template>
  </custom-card>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import CustomCard from '@/components/custom/CustomCard.vue';
import Profile from '@/components/bot/profile/Profile.vue';
import Ranking from '@/components/bot/profile/Ranking.vue';
import Commands from '@/components/bot/profile/Commands.vue';
import SongQueue from '@/components/bot/profile/SongQueue';
import { Kick } from '@/services/Kick';
import { Backend } from '@/services/Backend';
import { Utils } from '@/modules/utils';
import KickletTabs from '@/components/custom/kicklet/KickletTabs.vue';

const router = useRouter();
const route = useRoute();

const streamerData = ref(null);
const kickletUser = ref(null);
const profileSettings = ref(null);

const tabs = computed(() => {
  const baseTabs = [{ id: 'profile', text: 'Profile', icon: 'mdi-account' }];
  if (profileSettings.value) {
    if (profileSettings.value.rankingActive) {
      baseTabs.push({ id: 'ranking', text: 'Ranking', icon: 'mdi-trophy' });
    }
    if (profileSettings.value.songRequestsActive) {
      baseTabs.push({ id: 'song-queue', text: 'Song Queue', icon: 'mdi-playlist-music' });
    }
    if (profileSettings.value.commandListActive) {
      baseTabs.push({ id: 'commands', text: 'Commands', icon: 'mdi-hammer-screwdriver' });
    }
  }
  return baseTabs;
});

const tab = ref('profile');

const navigateToStats = (tabId) => {
  tab.value = tabId;
  router.push({ name: 'PublicProfile', params: { profileTab: tabId } });
};

onBeforeRouteUpdate((to) => {
  tab.value = to.params.profileTab || 'profile';
});

watch(tab, () => {
  if (tab.value !== route.params.profileTab) {
    router.push({ name: 'PublicProfile', params: { profileTab: tab.value } });
  }
});

onMounted(async () => {
  if (route.params.profileTab) {
    tab.value = route.params.profileTab;
  } else {
    await router.push({ name: 'PublicProfile', params: { profileTab: tab.value } });
  }
  try {
    const [streamerResponse, userResponse] = await Promise.all([
      Kick.getStreamerData(route.params.streamer),
      Backend.getUserByKickUsername(route.params.streamer),
    ]);

    streamerData.value = streamerResponse;
    kickletUser.value = userResponse.data;

    const settingsResponse = await Backend.getProfileSettings(kickletUser.value.id);
    profileSettings.value = settingsResponse.data;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
});
</script>

<style scoped>
</style>
